module.exports = __webpack_public_path__ + "static/media/login.a1c9ce5c.jpg";